<template>
  <div>
    <el-dialog
      custom-class="cancel-dialog dialog-bg-m"
      :show-close="false"
      center
      :append-to-body="true"
      title="註銷提醒"
      :visible.sync="isAccountCancelVisible"
      :before-close="closeDialog"
    >
      <p>
        如果您不再使用此帳號，可以將其註銷。<br />
        帳號成功註銷後，<span style="color: red">該帳號下所有遊戲</span
        >的個人資訊（包括但不限頭像、暱稱、儲值和消費記錄、好友關係、歷史戰績、段位與等級等）將進行刪除或匿名化處理，
        <span style="color: red">且無法恢復</span>，請您謹慎操作。
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="nextCancel">繼續註銷</el-button>
        <el-button size="medium" @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      custom-class="cancel-dialog dialog-bg-s"
      center
      :append-to-body="true"
      :visible.sync="show_confirm_success"
      :show-close="false"
      :before-close="closeDialog"
    >
      <p>註銷成功</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="confirmSuccess">確定</el-button>
      </span>
    </el-dialog>

    <el-dialog :append-to-body="true" :visible="options.isLoading">
      <loading :options="options"></loading>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/pc/store";
import Loading from "../common/Loading.vue";

export default {
  components: { Loading },
  props: {
    show_account_cancel: Boolean,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入密碼"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    return {
      options: {
        isLoading: false,
      },
      isAccountCancelVisible: this.show_account_cancel,
      show_login_games: false,
      show_identity: false,
      identity_title: "身份驗證",
      isThirdLogin: false,
      type: "apple",
      swiperOption: {
        initialSlide: 0,
        slidesPerView: "auto",
        spaceBetween: 1,
        grabCursor: true,
        autoHeight: true,
        observeParents: true,
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
      },
      ruleForm: {
        account: "",
        password: "",
      },
      rules: {
        password: [
          {
            require: true,
            message: "請輸入密碼",
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      cancel_id: null,
      show_confirm_success: false,
    };
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.cancel_id = null;
      this.$emit("closeDialog", false);
    },
    nextCancel() {
      this.deactiveAccount();
      this.isAccountCancelVisible = false;
    },
    deactiveAccount() {
      this.postHttp(this, {}, "/front/deletion", function (obj, data) {
        if (data.status === 2000) {
          obj.show_confirm_success = true;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    confirmSuccess() {
      this.show_confirm_success = false;
      this.logOut();
    },
    async login() {
      return new Promise((resolve) => {
        this.postHttp(this, this.ruleForm, "/front/login", function (obj, data) {
          let valid;
          if (data.status === 2000) {
            valid = true;
          } else {
            obj.$toast(data.message);
            valid = false;
          }
          resolve(valid);
        });
      });
    },
    logOut: function () {
      this.options.isLoading = true;
      this.options.isLoading = false;
      this.$store.commit("setIsHmsLogin", true);
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      this.$emit("LoginRegisterShow", true);
      this.$toast("已註銷");
      this.$router.push({ path: "/home" });
    },
  },
};
</script>
<style lang="stylus" scoped>
.login_wrapper {
  display: flex;
  align-items: flex-start;
  height: 190px;
}

.login_wrapper >>> .swiper-container {
  position: absolute;
  list-style: none;
  padding: 0;
  z-index: 0;
  width: 660px;
  left: 50%;
  top: 100px;
  margin-left: -330px;
}

.login_wrapper >>> .swiper-slide {
  width: 140px;
  height: 190px;
  flex: 1;
  text-align: center;
  margin-left: 11px;
  div {
    margin-top: 10px;
  }
}

.login_wrapper >>> .swiper-slide p {
  color: #333333;
  font-size: 16px;
}

.login_wrapper >>> .swiper-slide img {
  width: 120px;
  height: 120px;
  border-radius: 36px;
  transition: transform 0.9s ease 0s;
}

.login_wrapper >>> .swiper-slide img:hover {
  transform: scale(1.05, 1.05);
  animation: 0.9s ease-in-out;
}


.swiper-button-prev {
  width: 45px !important;
  height: 61px !important;
  background: url('../../assets/imgs/prevfb.png') no-repeat !important;
  background-size: 100% 100% !important;
  left: 17px !important;
  outline: none !important;
  margin-top: -2px !important;
}

.swiper-button-next {
  width: 45px !important;
  height: 61px !important;
  background: url('../../assets/imgs/nextfb.png') no-repeat !important;
  background-size: 100% 100% !important;
  right: 17px !important;
  outline: none !important;
  margin-top: -2px !important;
}

.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
  content: '';
}

.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
  content: '';
}

.dialog_inner {
  width: 99%;
  height 245px;
  margin: auto;
  background: white;
  padding: 25px 25px 30px;
  box-sizing: border-box;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}

.thirdLogin {
  position: relative;
  width: 229px;
  height: 63px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  a {
    content: '';
    width: 64px;
    height: 64px;
    background: url('../../assets/imgs/btn_third_login.png') no-repeat center;
    background-size: 229px 63px;
    opacity: 1;
    margin-left: calc((229px - 64px) / 2);

    &:hover {
      opacity: 0.85;
    }

    &:nth-child(1) {
      left: 0;
      background-position: 0 0;
    }

    &:nth-child(2) {
      left: 50%;
      margin-left: -32px;
      background-position: -84px 0;
    }

    &:nth-child(3) {
      right: 0;
      background-position: -166px 0;
    }
  }
}

.cancel_id_border {
  border: 2px solid #fcc916;
  border-radius: 10px;
  padding: 5px;
  animation: all 1s ease;
}
</style>
<style lang="stylus">
.van-toast {
  z-index: 10000 !important;
}
.identity-dialog {
  .el-dialog__footer {
    margin-top: -15px !important;
  }
}
.el-dialog {
  background: #FFF !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .3) !important;
}
.dialog-bg-s {
  background: url('../../assets/imgs/dialog_bg_s.png') no-repeat;
  background-size: 100% 100%;
  width: 330px;
  height: 200px;
  padding: 20px;
}
.dialog-bg-m {
  background: url('../../assets/imgs/dialog_bg_s.png') no-repeat;
  background-size: 100% 100%;
  width: 445px;
  height: 340px;
  .el-dialog__header {
    padding: 15px 20px 10px !important;
  }

  .el-dialog__footer {
    margin-top: 25px;
  }
}
.cancel-dialog {
  top: 15%;
  box-shadow: unset !important;

  .el-dialog__title {
    color: white;
  }

  p {
    font-size: 18px;
    line-height: 26px;
  }

  a {
    color: #fcc916;
  }

  .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
  }

  .el-button {
    &:hover {
      color: #787878;
      border-color: #fcc916;
      background-color: #fff;
    }
  }

  .el-input {
    width: 366px;
  }
}
</style>
